import React, { useEffect } from "react";
import XIcon from "../../shared/icons/XIcon";

export function Toast({ message, type = "success", onClose, duration = 3000 }) {
  useEffect(() => {
    if (!message) return;
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [message, duration, onClose]);

  if (!message) return null;

  const bgColor =
    type === "success"
      ? "bg-green-300 text-green-900"
      : "bg-red-300 text-red-900";

  return (
    <div
      className={`fixed top-4 left-1/2 transform -translate-x-1/2 px-8 py-4 rounded shadow-md z-50 flex items-center justify-between min-w-[280px] ${bgColor}`}
      role="alert"
    >
      <span>{message}</span>
      <button
        onClick={onClose}
        aria-label="Закрыть"
        className="ml-4 text-xl font-bold focus:outline-none hover:text-gray-700"
        style={{ lineHeight: 1 }}
      >
        <XIcon/>
      </button>
    </div>
  );
}
